import { fallbackLocale } from '@manager/config/locale-config';

export const localStorageKey = 'locale';

export function getPersistedLanguage() {
  return localStorage[localStorageKey] || fallbackLocale;
}
